import { Component, inject } from '@angular/core';
import { LoggerService } from './logger.service';
import { LoadingService } from '../loading/loading.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-logger',
  standalone: true,
  imports: [MatCardModule, MatButtonModule, MatIconModule, MatListModule, MatProgressBarModule, CommonModule],
  templateUrl: './logger.component.html',
  styleUrl: './logger.component.css'
})
export class LoggerComponent {
  private loadingService = inject(LoadingService);
  private loggerService = inject(LoggerService);
  private subscriptions = new Subscription();
  private limitReg: number = 500;
  
  public oLogger: any[] = [];
  public show: number;
  public limit: number;

  constructor() {
    this.limit = 20;
    this.show = this.limit;
  }

  ngOnInit () {
    this.loadingService.show();

    const loggerSubscribe = this.loggerService.getLogs(this.limitReg).subscribe(
      logs => {
        this.oLogger = logs;
      }
    );

    this.subscriptions.add(loggerSubscribe);

    this.loadingService.hide();
  }

  ngOnDestroy () {
    this.subscriptions.unsubscribe();
  }

}
